import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { socket } from "../../../../utils/socketUtil";
import BottomNav from "../../../../containers/BottomNav";
import { useParams } from "react-router-dom";
// import { pageUrlGenerator } from "../games/DynamicCasinoPage";

const ExchangeSPMSportsLobbyPage = () => {
  const [lobbyUrl, setLobbyUrl] = useState();
  const { category } = useParams();

  useEffect(() => {
    try {
      if (localStorage.getItem("token") !== null) {
        // tab: z.string().optional(),
        // // Layout
        // headless: z.boolean().optional(),
        // sidebarType: z.nativeEnum(SIDERBAR_TYPES).optional(),
        // // Action URLS
        // homeUrl: z.string().url().optional(),
        // depositUrl: z.string().optional(),
        // signUpUrl: z.string().optional(),
        // signInUrl: z.string().optional(),
        // // Sports
        // sportsTypes: z.array(z.number()).optional(), // Allowed sportstypes

        const lobbyConfig = {
          config: {
            // launchPage: "",
            // headless: true,
            // tab: "cricket", // soccer, tennis, live, upcomming, favourite,horse
            // homeUrl: pageUrlGenerator("/home"),
            // depositUrl: pageUrlGenerator("/gatewaylist"),
            // signUpUrl: pageUrlGenerator("/mobile-number"),
            // signUsignInUrlpUrl: pageUrlGenerator("/sign-in"),
          },
        };
        socket.emit("get:spmsports_lobby", lobbyConfig, (res) => {
          if (typeof res?.data?.lobby === "string") {
            setLobbyUrl(res?.data?.lobby);
          }
        });
      }
    } catch (err) {
      console.error(err);
      return;
    }
  }, []);

  return (
    <div className="live_casino_page live">
      <div className="header-bg">
        <HeaderAfterLogin />
      </div>

      {!Boolean(lobbyUrl) ? (
        <div className="custom_placeholder_parent">
          <div className="custom_placeholder_child">
            <Spinner animation="grow" variant="primary" size="sm" />
            <Spinner animation="grow" variant="primary" size="sm" />
            <Spinner animation="grow" variant="primary" size="sm" />
          </div>
        </div>
      ) : (
        <div className="exchange_iframe">
          <iframe
            title="Exchange"
            src={lobbyUrl}
            frameBorder="0"
            // scrolling="no"
            allowFullScreen={true}
            style={{ height: "100vh", width: "100%" }}
          >
            Your browser doesn't support iFrames.
          </iframe>
        </div>
      )}
      {/*  Iframe End */}

      {/* <BottomNav /> */}
    </div>
  );
};

export default ExchangeSPMSportsLobbyPage;
